import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export interface SchoolFeatures {
  risk_checker?: boolean;
}

interface SchoolSettings {
  feature_flags?: SchoolFeatures;
  features?: SchoolFeatures;
}

export function useSchoolFeatures(): SchoolFeatures {
  const { user } = useAuth();
  const schoolSlug = user?.schoolSlug;

  const { data } = useQuery({
    queryKey: ["school-features", schoolSlug],
    queryFn: async () => {
      if (!schoolSlug) return {};

      const { data } = await supabase
        .from("schools")
        .select("settings")
        .eq("slug", schoolSlug)
        .maybeSingle();

      const settings = data?.settings as SchoolSettings | null;
      return settings?.feature_flags ?? settings?.features ?? {};
    },
    enabled: !!schoolSlug,
    staleTime: 5 * 60 * 1000,
  });

  return data ?? {};
}
